import React from "react"
import { Image as ChakraImage, Box, Link } from "@chakra-ui/react"
import { QRCodeBlock } from "sharedTypes/builder"
import { useCurrentEvent } from "queries/events"

const QRCode = ({ block: { data } }: { block: QRCodeBlock }) => {
  const {
    data: {
      expiringQrCodes,
      translations: { temporalQrCodeForCheckIn },
    },
  } = useCurrentEvent()

  return (
    <Box
      bgColor={data.blockColor}
      pt={`${data.paddingTop * 4}px`}
      pb={`${data.paddingBottom * 4}px`}
    >
      {expiringQrCodes ? (
        <Box backgroundColor="white" px={5} py={2.5} borderRadius="md" w="fit-content" mx="auto">
          <ChakraImage
            src="https://data.diobox.com/app/email/temporal-qr-code-pre@2x.jpg"
            w={132}
            h={84}
            mx="auto"
          />
          <Link
            mx="auto"
            w={48}
            boxSizing="content-box"
            borderWidth={1}
            px={6}
            py={2}
            display="block"
            textAlign="center"
            color="blue.500"
            textDecoration="underline"
            pointerEvents="none"
          >
            {temporalQrCodeForCheckIn}
          </Link>
        </Box>
      ) : (
        <ChakraImage
          src="https://data.diobox.com/app/web/assets/email/qr-code-sample.png"
          w={100}
          h={100}
          mx="auto"
        />
      )}
    </Box>
  )
}

export default QRCode
